import { InfoCircleOutlined } from "@ant-design/icons";
import { Checkbox, InputNumber, Space, Tooltip, Typography } from "antd";

const { Text } = Typography;

export const DEFAULT_SAMPLE_SIZE = 100;
export const MIN_SAMPLE_SIZE = 1;
export const MAX_SAMPLE_SIZE = 5000;

/**
 * Opt-in auto-configure control (PRE-2722 AC1, AC2).
 *
 * Default is OFF and must stay that way: the whole feature is opt-in, and a
 * checked-by-default box would make inference the path of least resistance
 * rather than a choice.
 *
 * Rendered only for sources that can supply data. DDL and manual definition
 * never see it; the caller gates that.
 */
function SchemaAutoConfigureOptions({
    enabled,
    sampleSize,
    onEnabledChange,
    onSampleSizeChange,
    disabled = false,
    disabledReason = null,
}) {
    const control = (
        <Space orientation="vertical" size={4}>
            <Checkbox
                checked={enabled}
                disabled={disabled}
                onChange={(event) => onEnabledChange(event.target.checked)}
                data-testid="auto-configure-checkbox"
            >
                <Space size={4}>
                    <span>Auto-configure rules from sample data</span>
                    <Tooltip title="Reads a small sample of rows and suggests field types and constraints. Every suggestion is reviewed by you before anything is applied.">
                        <InfoCircleOutlined className="text-slate-400" />
                    </Tooltip>
                </Space>
            </Checkbox>

            {enabled && (
                <Space size={8} className="pl-6">
                    <Text type="secondary" className="text-xs">
                        Rows to sample
                    </Text>
                    <InputNumber
                        size="small"
                        min={MIN_SAMPLE_SIZE}
                        max={MAX_SAMPLE_SIZE}
                        value={sampleSize}
                        onChange={(value) => onSampleSizeChange(value || DEFAULT_SAMPLE_SIZE)}
                        style={{ width: 90 }}
                        data-testid="auto-configure-sample-size"
                    />
                    <Text type="secondary" className="text-xs">
                        A larger sample gives better suggestions but takes longer.
                    </Text>
                </Space>
            )}
        </Space>
    );

    if (disabled && disabledReason) {
        return <Tooltip title={disabledReason}>{control}</Tooltip>;
    }
    return control;
}

export default SchemaAutoConfigureOptions;
